import React, { createContext, useContext, useState } from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({ show: false, message: "", variant: "info" });

  const showToast = (message, variant = "info") => {
    setToast({ show: true, message, variant });
  };

  const hideToast = () => {
    setToast((prev) => ({ ...prev, show: false }));
  };

  const getHeaderStyle = () => {
    switch (toast.variant) {
      case "danger":
        return {
          backgroundColor: "rgba(244, 63, 94, 0.1)",
          color: "#e11d48",
          borderBottom: "1px solid rgba(244, 63, 94, 0.15)",
        };
      case "success":
        return {
          backgroundColor: "rgba(16, 185, 129, 0.1)",
          color: "#059669",
          borderBottom: "1px solid rgba(16, 185, 129, 0.15)",
        };
      case "warning":
        return {
          backgroundColor: "rgba(245, 158, 11, 0.1)",
          color: "#d97706",
          borderBottom: "1px solid rgba(245, 158, 11, 0.15)",
        };
      default:
        return {
          backgroundColor: "rgba(59, 130, 246, 0.1)",
          color: "#2563eb",
          borderBottom: "1px solid rgba(59, 130, 246, 0.15)",
        };
    }
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer position="top-end" className="p-4" style={{ zIndex: 9999, position: "fixed" }}>
        <Toast
          show={toast.show}
          onClose={hideToast}
          delay={4000}
          autohide
          style={{
            background: "rgba(255, 255, 255, 0.85)",
            backdropFilter: "blur(12px)",
            WebkitBackdropFilter: "blur(12px)",
            borderRadius: "16px",
            border: "1px solid rgba(255, 255, 255, 0.5)",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.06)",
            overflow: "hidden",
            minWidth: "280px",
          }}
        >
          <Toast.Header style={getHeaderStyle()} closeButton={true}>
            <strong className="me-auto text-[10px] font-bold uppercase tracking-wider">
              {toast.variant === "danger"
                ? "Error"
                : toast.variant === "success"
                ? "Success"
                : toast.variant === "warning"
                ? "Warning"
                : "Info"}
            </strong>
          </Toast.Header>
          <Toast.Body className="text-sm font-semibold text-slate-700 p-3">
            {toast.message}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
